// sanctum.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class SanctumService {
  private csrfLoadedByContext: Record<'user' | 'creator', boolean> = {
    user: false,
    creator: false
  };
  private csrfLoaded = false;

  constructor(private http: HttpClient) { }

  async initSanctum(ctx: 'user' | 'creator' = 'user'): Promise<void> {
    // não roda em storefronts de terceiros (Shopify / Nuvemshop / Tiendanube)
    if (window.location.origin.includes('myshopify.com')) return;
    if (window.location.origin.includes('lojavirtualnuvem.com.br')) return;
    if (window.location.origin.includes('tiendanube.com')) return;

    if (this.csrfLoadedByContext[ctx]) return;

    const base = `${environment.apiBaseUrl}`;

    await this.http.get(`${base}/sanctum/csrf-cookie`, {
      withCredentials: true,
      responseType: 'text',
      headers: new HttpHeaders({
        'X-Auth-Context': ctx,
        'ngsw-bypass': 'true',
      })
    }).toPromise();

    this.csrfLoadedByContext[ctx] = true;
  }
}
